// extracted by mini-css-extract-plugin
export default {"simpleSearchWrapper":"Search_simpleSearchWrapper__Zj4EG","searchInputWrapper":"Search_searchInputWrapper__1YpcP","inputTextWrapper":"Search_inputTextWrapper__sJDyD"};